import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AnnualPricing, AuditType, Fee} from "../../../../store/state/order.state";
import {AuditTypeFees} from "../product-pricing/product-pricing.component";

@Component({
    selector: 'price-card',
    templateUrl: './price-card.template.html',
    styleUrls: ['./price-card.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PriceCardComponent {

	@Input() annualPricing: AnnualPricing;
	@Input() pricingYear: number;
	@Input() includeOffsiteDays: boolean;
	@Input() feesByAuditType: AuditTypeFees[] = [];


	feesForAuditType(auditType: AuditType): Fee[] {
		return this.feesByAuditType.find(f => f.auditType === auditType)?.fees ?? [];
	}

	totalPrice(): number {
		const feesSum = this.feesByAuditType.reduce((sum, f) => sum + f.fees.reduce((s, fee) => s + fee.amount, 0), 0);
		return feesSum + this.annualPricing.auditPricings.map(ap => ap.price).reduce((p1, p2) => p1 + p2, 0);
	}
}
